import { render, staticRenderFns } from "./FormPromotionRoi.vue?vue&type=template&id=42af3037&scoped=true&"
import script from "./FormPromotionRoi.vue?vue&type=script&lang=js&"
export * from "./FormPromotionRoi.vue?vue&type=script&lang=js&"
import style0 from "./FormPromotionRoi.vue?vue&type=style&index=0&id=42af3037&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42af3037",
  null
  
)

export default component.exports